import React, { useEffect, useState } from "react";
import { object } from "prop-types";
import get from "lodash/get";
import trimStart from "lodash/trimStart";

import FourColPortraitStories from "../../../../arrow/components/Rows/FourColPortraitStories";

export const ArrowFourColPortraitStories = ({ collection, pageType }) => {
  const config = {
    buttonText: `Read More`,
    showImagePlaceholder: true,
    showSection: false,
    showReadTime: false,
  };

  const [items, setItems] = useState(collection.items);
  const isShortVideo = get(collection, ["associated-metadata", "is_short_videos"], false);

  useEffect(() => {
    if (isShortVideo) {
      const fetchData = async () => {
        try {
          const res = await fetch(
            `https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/ytshorts-data/shorts.json`
          );
          const data = await res.json();
          if (Array.isArray(data) && data.length > 0) {
            data.forEach((item) => {
              if (item.story && typeof item.story.slug === "string") {
                item.story.slug = trimStart(item.story.slug, "/");
              }
            });
          }
          setItems(data.slice(0, 4));
        } catch (error) {
          console.log("YT Shorts Error fetching data:", error);
        }
      };

      fetchData();
    }
  }, [isShortVideo]);

  return (
    <FourColPortraitStories
      collection={{ ...collection, items }}
      config={config}
      isLoadMoreVisible={true}
      pageType={pageType}
    />
  );
};

ArrowFourColPortraitStories.propTypes = {
  collection: object,
};

ArrowFourColPortraitStories.storyLimit = 14;
